import DoctorChatBox from "../chat/chatBox";
import Footer from "../footer";
import DoctorHeader from "./Header";

export default function DoctorChat() {


    return (
        <>

            <DoctorHeader />

            <section  style={{  marginTop:  "3cm"}}>
                

                <DoctorChatBox />


            </section>




            <Footer />


        </>

    );


}